import { useEffect } from 'react';
import { Button, Card, Stack, Text, Title } from '@mantine/core';
import { IconCircleX } from '@tabler/icons-react';
import CustomerLayout from '@/components/layout/CustomerLayout';
import { isPostHogEnabled, posthog } from '@/lib/posthog';

interface CustomerQuoteUnavailableProps {
  hasToken?: boolean;
}

export function CustomerQuoteUnavailable({ hasToken = false }: CustomerQuoteUnavailableProps) {
  useEffect(() => {
    if (!isPostHogEnabled) return;
    posthog.capture('customer_quote_unavailable', {
      pathname: window.location.pathname,
      hasToken,
    });
  }, [hasToken]);

  return (
    <CustomerLayout>
      <Card withBorder radius="md" padding="xl">
        <Stack gap="md" align="center" ta="center">
          <IconCircleX size={48} color="var(--mantine-color-red-6)" />
          {hasToken ? (
            <>
              <Title order={3}>We couldn&apos;t load this quote right now</Title>
              <Text c="dimmed" maw={520}>
                Something went wrong on our end. Please try again — if you&apos;ve just completed a
                payment, it has not been affected.
              </Text>
              <Button variant="default" onClick={() => window.location.reload()}>
                Try again
              </Button>
            </>
          ) : (
            <>
              <Title order={3}>We couldn&apos;t open this quote link</Title>
              <Text c="dimmed" maw={520}>
                This link looks incomplete. Open the original link from your email, or reply to that
                email for a new one.
              </Text>
            </>
          )}
        </Stack>
      </Card>
    </CustomerLayout>
  );
}
